import React from 'react'
import HTML from '../assets/html.png';
import CSS from '../assets/css.png';
import JavaScript from '../assets/j.png';
import ReactImg from '../assets/react.png';
import Node from '../assets/node.png';
import AWS from '../assets/aws.png';
import GitHub from '../assets/github.png';
import Tailwind from '../assets/tailwind.png';
import Mongo from '../assets/mongo.png';
import Express from '../assets/ex.png';
import redux from '../assets/redux.png';

function Skill() {
  return (
    <div name='skills' className='w-full h-fit  pt-9 bg-[#0a192f] text-gray-300'>
      {/* Container */}
      <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
          <div className='text-center'>
              <p className='text-6xl  font-bold inline border-b-4 border-pink-600 '>Skills</p>
              <p className='py-4 text-xl mt-4'> These are the technologies I've worked with</p>
          </div>

          <div className='w-full grid grid-cols-2 sm:grid-cols-5  gap-8 text-center py-8'>
              <div className='shadow-md shadow-[#f3f3fc]   rounded-lg  border-2 hover:scale-110 duration-500 p-2'>
                  <img className='w-20 mt-3 mx-auto grayscale' src={HTML} alt="HTML" />
                  <p className='my-4  font-bold'>HTML</p>
              </div>
              <div className='shadow-md shadow-[#f3f3fc] rounded-lg  border-2 hover:scale-110 duration-500 p-2'>
                  <img className='w-20 mt-3 mx-auto grayscale' src={CSS} alt="CSS" />
                  <p className='my-4  font-bold'>CSS</p>
              </div>
              <div className='shadow-md shadow-[#f3f3fc]  rounded-lg  border-2 hover:scale-110 duration-500 p-2'>
                  <img className='w-16 mt-3 mx-auto grayscale' src={JavaScript} alt="JS" />
                  <p className='my-4  font-bold'>JAVASCRIPT</p>
              </div>
              <div className='shadow-md shadow-[#f3f3fc]   rounded-lg  border-2 hover:scale-110 duration-500 p-2'>
                  <img className='w-20 mt-3 mx-auto grayscale' src={ReactImg} alt="React" />
                  <p className='my-4  font-bold'>REACT</p>
              </div>

              <div className='shadow-md shadow-[#f3f3fc]  rounded-lg  border-2 hover:scale-110 duration-500 p-2'>
              <img className='w-20  mt-3 mx-auto grayscale' src={redux} alt="HTML icon" />
              <p className='my-4  font-bold'>REDUX</p>
          </div>

              <div className='shadow-md shadow-[#f3f3fc]  rounded-lg  border-2 hover:scale-110 duration-500 p-2'>
              <img className='w-20 mt-3 mx-auto grayscale' src={Tailwind} alt="Tailwind css" />
              <p className='my-4  font-bold'>TAILWIND CSS</p>
            </div>

              <div className='shadow-md shadow-[#f3f3fc]  rounded-lg  border-2 hover:scale-110 duration-500 p-2'>
              <img className='w-20 mt-3
              mx-auto grayscale' src={Mongo} alt="Mongo DB" />
              <p className='my-4  font-bold'>MONGO DB</p>
          </div>



          <div className='shadow-md shadow-[#f3f3fc]  rounded-lg  border-2 hover:scale-110 duration-500 p-2'>
                  <img className='w-20 mt-3 mx-auto grayscale' src={Node} alt="Node Js" />
                  <p className='my-4 font-bold'>NODE JS</p>
              </div>
              <div className='shadow-md shadow-[#f3f3fc]  rounded-lg  border-2 hover:scale-110 duration-500 p-2'>
              <img className='w-20  mt-3 mx-auto grayscale' src={Express} alt="Express" />
              <p className='my-4 font-bold'>EXPRESS JS</p>
          </div>

             
              
             
            

              <div className='shadow-md shadow-[#f3f3fc]  rounded-lg  border-2 hover:scale-110 duration-500 p-2'>
              <img className='w-20 mx-auto mt-3 grayscale' src={GitHub} alt="HTML icon" />
              <p className='my-4  font-bold'>GITHUB</p>
          </div>
             
          </div>
      </div>
    </div>
    )
}

export default Skill 


// git init
// git add <folder1> <folder2> <etc.>
// git commit -m "Your message about the commit"
// git remote add origin https://github.com/vivekKumarSinghH/Portfolio
// git push -u origin master
// git push origin master